
export default function SecuritySection() {
  const securityFeatures = [
    { icon: 'ri-shield-check-line', title: 'SSL Encryption', desc: '256-bit encryption security' },
    { icon: 'ri-eye-line', title: 'Anti-Fraud AI', desc: 'AI-based fraud detection' },
    { icon: 'ri-user-search-line', title: 'KYC Verification', desc: 'Country-specific compliance' },
    { icon: 'ri-check-double-line', title: 'Official Slot API', desc: 'Certified API integration' },
    { icon: 'ri-percent-line', title: 'RTP Transparency', desc: 'All RTP publicly disclosed' },
    { icon: 'ri-safe-line', title: 'Separate Wallet', desc: 'Secure asset management' }
  ];

  return (
    <section className="py-16 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-white mb-4" style={{ fontFamily: 'Orbitron, sans-serif' }}>
            🛡 <span className="text-[#FFD349]">Platform Security System</span>
          </h2>
          <p className="text-xl text-white/80" style={{ fontFamily: 'Montserrat, sans-serif' }}>User funds are stored in separate secure wallets</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {securityFeatures.map((feature, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-[#1a1c24] to-[#111319] rounded-2xl p-6 border border-[#00D8FF]/30 hover:border-[#00D8FF]/60 hover:scale-105 transition-all duration-300 shadow-lg"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#00D8FF]/20 to-[#00D8FF]/10 rounded-xl mb-4">
                <i className={`${feature.icon} text-[#00D8FF] text-3xl`}></i>
              </div>
              <h3 className="text-white font-bold text-lg mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>✔ {feature.title}</h3>
              <p className="text-white/70 text-sm" style={{ fontFamily: 'Montserrat, sans-serif' }}>{feature.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-[#00D8FF]/10 to-[#FFD349]/10 border-2 border-[#00D8FF]/30 rounded-2xl p-8 text-center">
          <div className="flex items-center justify-center space-x-4 mb-4">
            <i className="ri-shield-star-line text-[#00D8FF] text-5xl"></i>
            <i className="ri-link text-[#FFD349] text-3xl"></i>
            <i className="ri-scan-line text-[#00D8FF] text-5xl"></i>
          </div>
          <p className="text-white text-lg font-semibold" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Protected by industry-leading security systems
          </p>
        </div>
      </div>
    </section>
  );
}
